module.exports = globalThis.mcData["biomesArray"] ?? globalThis.mcData["biomes"]